import { motion, useReducedMotion } from 'framer-motion';
import { Check, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function PublicSurveySubmitting() {
  const { t } = useTranslation();
  const reduceMotion = useReducedMotion();

  return (
    <div className="glass flex flex-col items-center gap-6 rounded-2xl px-6 py-14 text-center">
      {!reduceMotion ? (
        <motion.div
          className="relative grid size-20 place-items-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <motion.span
            className="absolute inset-0 rounded-full border-2 border-primary/30"
            animate={{ scale: [1, 1.35, 1], opacity: [0.5, 0, 0.5] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
          />
          <Loader2 className="size-10 animate-spin text-primary" />
        </motion.div>
      ) : (
        <Loader2 className="size-10 animate-spin text-primary" />
      )}
      <div className="space-y-1">
        <p className="text-lg font-semibold">{t('celebration.submittingTitle')}</p>
        <p className="text-sm text-muted-foreground">{t('celebration.submittingHint')}</p>
      </div>
    </div>
  );
}

const particles = [
  { x: -48, delay: 0 },
  { x: -16, delay: 0.08 },
  { x: 16, delay: 0.04 },
  { x: 48, delay: 0.12 },
  { x: -32, delay: 0.16 },
  { x: 32, delay: 0.06 },
];

export function PublicSurveySubmitCelebration() {
  const { t } = useTranslation();
  const reduceMotion = useReducedMotion();

  return (
    <div className="glass flex flex-col items-center gap-6 rounded-2xl px-6 py-14 text-center">
      <div className="relative">
        {!reduceMotion ? (
          <>
            <motion.span
              className="absolute inset-0 m-auto size-24 rounded-full bg-success/20"
              initial={{ scale: 0.6, opacity: 0.6 }}
              animate={{ scale: 1.8, opacity: 0 }}
              transition={{ duration: 0.9, ease: 'easeOut' }}
            />
            {particles.map((p, i) => (
              <motion.span
                key={i}
                className="absolute left-1/2 top-1/2 size-2 rounded-full bg-primary/60 blur-[1px]"
                initial={{ x: 0, y: 0, opacity: 0 }}
                animate={{ x: p.x, y: -56 - i * 8, opacity: [0, 1, 0] }}
                transition={{ duration: 1.1, delay: p.delay, ease: 'easeOut' }}
              />
            ))}
          </>
        ) : null}
        <motion.div
          className="relative grid size-20 place-items-center rounded-full bg-success text-success-foreground shadow-soft"
          initial={reduceMotion ? { opacity: 0 } : { scale: 0, opacity: 0 }}
          animate={reduceMotion ? { opacity: 1 } : { scale: 1, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 320, damping: 22 }}
        >
          <Check className="size-10 stroke-[2.5]" />
        </motion.div>
      </div>
      <motion.div
        className="space-y-2"
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: reduceMotion ? 0 : 0.25, duration: 0.35 }}
      >
        <h2 className="text-xl font-semibold">{t('celebration.successTitle')}</h2>
        <p className="text-sm text-muted-foreground">{t('celebration.successHint')}</p>
      </motion.div>
    </div>
  );
}
